import { InputFieldProps } from "../types";

// Search match for a FieldsGroupWrapper row: any important string field contains the query.
export const showItem = (
  searchQuery: string,
  importantFields: string[],
  data: InputFieldProps[],
) =>
  data.some(
    ({ key, value }) =>
      importantFields.includes(key) &&
      typeof value === "string" &&
      value.toLowerCase().includes(searchQuery),
  );
